import { lazy, Suspense } from "react";
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/setup/users/main'));

const Users = () => {
    return (
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )
}

export default Users;